import {
    GETSUBADMINMANAGEMENTLISTADMIN_SUCCESS,
    GETSUBADMINMANAGEMENTLISTADMIN_FAILED,
    RESET_GETSUBADMINMANAGEMENTLISTADMIN,
    LOADING_GETSUBADMINMANAGEMENTLISTADMIN,
    NETWORK_ERROR_GETSUBADMINMANAGEMENTLISTADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetSubAdminMgmtList = () => {
    return { type: RESET_GETSUBADMINMANAGEMENTLISTADMIN };
};

const AdminGetSubAdminMgmtLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETSUBADMINMANAGEMENTLISTADMIN });
    await adminServices
        .post("getsubadminManagementList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminGetSubAdminMgmtListsuccess(res.data));
                    break;
                default:
                    dispatch(AdminGetSubAdminMgmtListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETSUBADMINMANAGEMENTLISTADMIN,
                payload: err
            });
        });
};


function AdminGetSubAdminMgmtListsuccess(data) {
    return {
        type: GETSUBADMINMANAGEMENTLISTADMIN_SUCCESS,
        payload: data
    };
}
function AdminGetSubAdminMgmtListFailed(data) {
    return {
        type: GETSUBADMINMANAGEMENTLISTADMIN_FAILED,
        payload: data
    };
}

export { AdminGetSubAdminMgmtLists, resetAdminGetSubAdminMgmtList }